/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit můj košík`
};

const da_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Se min kurv`
};

const de_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Meinen Warenkorb anzeigen`
};

const en_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `View my cart`
};

const es_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Ver mi carrito`
};

const fr_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Voir mon panier`
};

const hu_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Kosár megtekintése`
};

const it_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi il mio carrello`
};

const nl_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk mijn winkelwagen`
};

const pl_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Zobacz mój koszyk`
};

const pt_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Ver meu carrinho`
};

const sv_view_my_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Visa min kundvagn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const view_my_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.view_my_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("view_my_cart", locale)
	if (locale === "cs") return cs_view_my_cart(inputs)
	if (locale === "da") return da_view_my_cart(inputs)
	if (locale === "de") return de_view_my_cart(inputs)
	if (locale === "en") return en_view_my_cart(inputs)
	if (locale === "es") return es_view_my_cart(inputs)
	if (locale === "fr") return fr_view_my_cart(inputs)
	if (locale === "hu") return hu_view_my_cart(inputs)
	if (locale === "it") return it_view_my_cart(inputs)
	if (locale === "nl") return nl_view_my_cart(inputs)
	if (locale === "pl") return pl_view_my_cart(inputs)
	if (locale === "pt") return pt_view_my_cart(inputs)
	return sv_view_my_cart(inputs)
};